import React from 'react';
import { SubtractCircleIcons } from '../../../../icons/icons';
import { SubSkillsDrawerProps } from '../interfaces';

export const SubSkillsDrawer = ({
  subSkills,
  onDeleteSubSkill,
}: SubSkillsDrawerProps) => {
  return (
    <div className='mt-2.5 pt-2.5 border-t border-gray-100 bg-gray-50/70 -mx-3.5 -mb-3.5 p-3 rounded-b-xl space-y-1.5 max-h-48 overflow-y-auto'>
      <div className='flex items-center justify-between text-[11px] font-semibold text-gray-500 uppercase tracking-wider mb-1 px-1'>
        <span>Sub-skills ({subSkills.length})</span>
      </div>
      {subSkills.map((subSkill) => (
        <div
            key={subSkill.id}
            className='flex items-center justify-between py-1.5 px-2.5 rounded-lg bg-white border border-gray-200/70 hover:border-gray-300 transition-colors group/sub text-xs'
        >
          <span
              className='text-gray-700 truncate mr-2'
              title={subSkill.subskillName}
          >
            {subSkill.subskillName}
          </span>
          <button
              onClick={() => onDeleteSubSkill(subSkill.id)}
              className='opacity-0 group-hover/sub:opacity-100 text-red-500 hover:text-red-700 p-0.5 rounded transition-all shrink-0'
              title='Delete sub-skill'
              aria-label={`Delete sub-skill ${subSkill.subskillName}`}
          >
            <SubtractCircleIcons className='w-3.5 h-3.5' />
          </button>
        </div>
      ))}
    </div>
  );
};
